import script from "./Summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./Summary.vue?vue&type=script&setup=true&lang=ts"

import "./Summary.vue?vue&type=style&index=0&id=027e16b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027e16b4"]])

export default __exports__